import apiRoutes from './api.routes';
import ModelService from './model.service';

const PostService = new ModelService(apiRoutes.posts, '/posts', 'blog');

PostService.getImage = (filename, w = false, h = false, c = false) => PostService.getFilePathByDir('/uploads/posts', filename, w, h, c);

export default PostService;



// WEBPACK FOOTER //
// ./src/services/post.service.js